import { render, staticRenderFns } from "./HighestBid.vue?vue&type=template&id=0335aac7&"
import script from "./HighestBid.vue?vue&type=script&lang=js&"
export * from "./HighestBid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports